export function debugLog(...args: unknown[]) {
    if (import.meta.env.VITE_DEBUG_LOGS === 'true') {
        // eslint-disable-next-line no-console
        console.log(...args)
    }
}
